import React, { ComponentType, useEffect } from "react"
import { compose } from "@reduxjs/toolkit"
import { useNavigate } from "react-router-dom"
import { FormikHelpers as FormikActions } from "formik"

import { withVerification } from "hocs/features"
import { useAppDispatch } from "redux/hooks"
import { makeMobileIdAuthentication } from "redux/features/auth/mobileIdThunk"
import { showAlert } from "redux/features/notice/noticeSlice"
import { reset as resetVerification } from "redux/features/verification/verificationSlice"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"

import { Content, Card } from "pages/sessions/elements"
import MobileIdForm from "components/Sessions/MobileId/Form"
import Title from "components/Sessions/Title"
import Code from "components/ui/Code"
import { MOBILE_ID_PERSONAL_CODE, MOBILE_ID_PHONE_NUMBER } from "config"
import { ClientMobileIdFormValues } from "types"

type Props = React.HTMLAttributes<HTMLDivElement> & { code: number }

const MobileIdPage = ({ code }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleSubmit = (
    values: ClientMobileIdFormValues,
    actions: FormikActions<object>,
  ) => {
    const { personal_code, phone } = values

    dispatch(makeMobileIdAuthentication({ personal_code, phone_number: phone }))
      .then(() => {
        navigate("/")
      })
      .catch((error) => {
        dispatch(showAlert({ message: error }))
        actions.setSubmitting(false)
      })
  }

  const handleCancel = () => {
    dispatch(resetVerification())
    dispatch(resetPolling())
  }

  useEffect(() => {
    handleCancel()
  }, [])

  return (
    <Content data-testid="login-mobile-id-page">
      <Card elevation={0}>
        <Title back />
        {code ? (
          <Code light code={code} onCancel={handleCancel} />
        ) : (
          <MobileIdForm
            initialValues={{
              personal_code: MOBILE_ID_PERSONAL_CODE,
              phone: MOBILE_ID_PHONE_NUMBER,
              terms: true,
            }}
            onSubmit={handleSubmit}
          />
        )}
      </Card>
    </Content>
  )
}

export default compose<ComponentType>(withVerification)(MobileIdPage)
